/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { useState, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { StatusContext, StatusContextType } from './StatusContext';

export function BeButton({ label, doit, className="" } : { label: string; doit: () => Promise<void>; className?: string }) {
    const [errorMessage, setErrorMessage] = useState("");
    const statusContext = useContext(StatusContext);
    return (
        <div className={className}>
            <Button variant="primary" onClick={() => {
                const work = async () => {
                    try {
                        await doit();
                    } catch (error : any) {
                        statusContext.postError(`Error: ${error.message}`);
                    }
                }
                work();
            }} >
            {label}
            </Button>
        </div>
    );
}